import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Được phát triển bởi Halovi"
      links={[
        {
          key: 'ubnd',
          title: (
            <span
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
            >
              UBND Phường Cẩm Lệ
              <img
                src="/logo-camle.png"
                alt="Logo"
                style={{ height: 20, verticalAlign: 'middle' }}
              />
              Hệ thống xếp hàng thông minh
            </span>
          ),
          href: '#',
          blankTarget: false,
        },
      ]}
    />
  );
};

export default Footer;
